import React, { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";
import { Navigate, Link } from "react-router-dom";
import { Trash2 } from "lucide-react";

export default function Saved() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  useEffect(() => { if (user) api.get("/saved-items").then((r) => setItems(r.data || [])); }, [user?.id]);
  if (!user) return <Navigate to="/giris" replace />;

  const remove = async (id) => {
    try { await api.delete(`/saved-items/${id}`); setItems(items.filter((i) => i.id !== id)); toast.success("Silindi"); } catch { toast.error("Hata"); }
  };

  return (
    <div className="max-w-4xl mx-auto px-4 py-6">
      <h1 className="text-2xl md:text-3xl font-black mb-5">Kaydettiklerim</h1>
      <div className="space-y-3">
        {items.length === 0 && <div className="text-gray-500 text-sm">Henüz bir içerik kaydetmediniz.</div>}
        {items.map((it) => {
          const link = it.entity === "news" ? `/haber/${it.data?.slug}` : it.entity === "column" ? `/yazi/${it.data?.slug}` : it.entity === "video" ? `/video/${it.entity_id}` : `/etkinlikler/${it.entity_id}`;
          const title = it.data?.title || "—";
          return (
            <div key={it.id} className="bg-white border border-gray-100 rounded-lg p-4 flex items-center justify-between">
              <div>
                <div className="text-[10px] uppercase text-[#e11d2a] font-bold">{it.entity}</div>
                <Link to={link} className="font-semibold hover:text-[#e11d2a]">{title}</Link>
              </div>
              <button onClick={() => remove(it.id)} className="text-gray-500 hover:text-red-600"><Trash2 className="w-4 h-4" /></button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
